import { CrmObjectName } from '../types'
import { useSchema } from './useSchema'

export const useMandatoryFields = (crmObjectName: CrmObjectName | undefined) => {
  const schemaData = useSchema(crmObjectName)

  return schemaData?.schema?.fields?.filter?.((f: any) => f?.isMandatory).map((f: any) => f?.name)
}
